module.exports = __webpack_public_path__ + "static/logo-white-8d798c07bec5aeb70e55b31899d83d54.svg";